import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../assets/img/svg/save.svg';
import Cancel from '../../../assets/img/svg/cancel.svg';
import Delete from '../../../assets/img/svg/delete.svg';
import download from "../../../assets/img/svg/DownloadIcon.svg";
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import del from '../../../assets/img/svg/Del.svg'
import { useNavigate } from "react-router-dom";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import styles from "../../../assets/jss/customStyle";
import $ from "jquery";
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import image from '../../../assets/img/svg/Image.svg';
import Ship from "../../../assets/img/svg/Ship.svg";
import Close from "@material-ui/icons/Close";
import axios from "axios";
import API from "../../../_helpers/endpointService";
import moment from "moment";
import { getSettingsFormat } from "../../../actions/SettingsAction";
import active from '../../../assets/img/svg/active.svg';
import deactive from '../../../assets/img/svg/deactive.svg';
import InnerImageZoom from "react-inner-image-zoom";
import { formatRelativeWithOptions } from "date-fns/fp";
import { shipOwnerRole, yardOwnerRole } from "../../common/commonJson";

class EditPlannedDate extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            value: 0,
            isView: false,
            ActualDateError: false,
            DocsError: false,
            fileUrl: "",
            fileName: "",
            DelIndex: 0,
            filename: "",
            index: 0,
            awsname: "",
            IfdeletePost: {
                "PlannedDate": null,
                "ActualDate": null,
                "Month": "",
                "Id": 0,
                "TrainingTitle": "",
                "TrainingId": 0,
                "Modify": localStorage.getItem("UserRoles")
            },
            addData: {
                "PlannedDate": null,
                "ActualDate": null,
                "Month": "",
                "Id": 0,
                "TrainingTitle": "",
                "TrainingId": 0,
                "Comments": "",
                "Modify": ""
            },
            Docs: [],

            ProjectId: 0,
            YardId: 0,
            TrainingId: 0,
            YardTraining: false,
            actionData: {},
            UserRole: "",
            DelId: {},
            PlannedDates: [],
            isSave: false,
        }
    }

    componentDidMount() {
        (localStorage.getItem("UserRoles") == shipOwnerRole) ? this.setState({ isView: true }) : this.setState({ isView: false })
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.YardId = localStorage.getItem("YardId");
        this.state.TrainingId = parseInt(localStorage.getItem("TrainingPlanEditId"));
        this.state.YardTraining = localStorage.getItem("YardTraining") == "true" ? true : false;
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.getedittpydocinfo(this.state.YardId, this.state.TrainingId, this.state.YardTraining)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#TrainingPlan1 .MuiListItemText-primary").removeClass("spanTopBar");
        $("#YTrainingPlan .MuiListItemText-primary").removeClass("fw-bolder");
        $("#TrainingPlan").addClass("d-none");
        $("#TrainingPlan").removeClass("d-block");
        $("#YardTrainingPlan").removeClass("active-color");
        $("#TrainingPlan").removeClass("fw-bolder");
    }

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebaryarddocument");
        }

    };

    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebaryarddocument");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#TrainingPlan1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#YTrainingPlan .MuiListItemText-primary").addClass("fw-bolder");
        $("#TrainingPlan").removeClass("d-none");
        $("#TrainingPlan").addClass("d-block");
        $("#YardTrainingPlan").addClass("active-color");
        $("#TrainingPlan").addClass("fw-bolder");
    };

    // AttachFiles = (e) => {
    //     this.inputFile.current.click();
    // };

    // UploadFile = (e) => {
    //     this.state.cancel = true;
    //     this.props.dispatch({ type: "CANCEL", data: true });
    //     Array.from(e.target.files).forEach(async (a) => {
    //         let upload = {
    //             FileName: a.name,
    //             FileSize: a.size,
    //             check: false,
    //             fdata: a,
    //             FileUrl: await this.toBase64(a),
    //         }
    //         this.state.Docs.push(upload)
    //         this.setState({})
    //     })
    // };

    // toBase64 = file => new Promise((resolve, reject) => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onload = () => resolve(reader.result);
    //     reader.onerror = error => reject(error);
    // });

    EditCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/yard/trainingplan")
        window.$("#cancelpopup").modal("hide")
    };

    OpenCancel = () => {
        // if (this.state.value == 1) {
        //     this.state.value = 0
        //     this.setState({})
        //     this.getedittpydocinfo(this.state.addData.Id)
        // }
        // else {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show")
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/yard/trainingplan`)
        }
        // }
    }

    getedittpydocinfo = (yardid, trainingId, yardTraining) => {
        let apiUrl = API.GET_YARDPLANNING + '/' + yardid + '/' + trainingId + '/' + yardTraining
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    response.data?.PlannedDate?.push({
                        "Id": 0,
                        "Date": ""
                    })
                    this.setState({
                        actionData: response.data
                    })
                    this.setState({})
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    EditSave = () => {
        this.state.cancel = false;
        this.props.dispatch({ type: "CANCEL", data: false });
        this.state.actionData?.PlannedDate?.map((value) => (
            value?.Id == 0 && value?.Date != "" ?
                this.state.PlannedDates?.push({
                    "ActualTrainingId": value?.Id,
                    "Action": "Add",
                    "PlannedDate": value?.Date,
                }) : ""
        ))
        this.setState({})
        let data = {
            "YardId": parseInt(this.state.YardId),
            "YardTrainingId": this.state.YardTraining == true ? this.state.actionData?.TrainingId : null,
            "CommonTrainingId": this.state.YardTraining == false ? this.state.actionData?.TrainingId : null,
            "PlannedDates": this.state.PlannedDates
        }
        this.put_data(data, this.state.actionData?.TrainingId)
    }

    put_data = (data, Id) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        let apiUrl = API.GET_YARDTRAININGPLAN + Id + '/' + "PlannedDate";
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/yard/trainingplan");
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    addtabledocinfo = (data, formData, id, array) => {
        let apiUrl = API.TRAINING_PLAN + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (array.length > 0) {
                        this.adduploadtabdocinfo(formData, id)
                    }
                    else {
                        this.props.dispatch({ type: "SHOW_LOADER", data: false })
                        this.props.navigate("/trainingplanofyard")
                    }
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {

                }
            });
    };

    adduploadtabdocinfo = (data, id) => {
        let apiUrl = API.TRAINING_PLAN + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (response?.status === 200) {
                    this.props.navigate("/trainingplanofyard")

                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };

    handleInputChange = (e, str, ind) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        const updateData = this.state.PlannedDates?.filter((r) => r?.ActualTrainingId == str.Id && str.ActualTrainingId != 0);
        if (updateData.length > 0) {
            updateData[0].PlannedDate = e.target.value;
        } else {
            if (str.Id != 0) {
                this.state?.PlannedDates?.push({
                    "ActualTrainingId": str.Id,
                    "Action": "Update",
                    "PlannedDate": e.target.value,
                })
            }
        }
        this.state.actionData?.PlannedDate?.map((r, index) => (
            str.Id == r.Id && index == ind ?
                (r.Date = e.target.value)
                : ""
        ))
        const data = this.state.actionData?.PlannedDate?.filter((r) => r?.Id == 0 && r.Date == "")
        if (str.Id == 0 && data?.length == 0) {
            this.state.actionData?.PlannedDate?.push({
                "Id": 0,
                "Date": ""
            })
        }
        this.setState({})
    }

    handleDelete = (ind, id) => {
        window.$("#deletepopupactual").modal("show");
        this.state.DelIndex = ind;
        this.state.DelId = id;
        this.setState({})
    }

    DeleteItemActual = () => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.actionData?.PlannedDate?.splice(this.state.DelIndex, 1);
        if (this.state.DelId?.Id != 0)
            this.state.PlannedDates?.push({
                "ActualTrainingId": this.state.DelId?.Id,
                "Action": "Delete",
                "PlannedDate": this.state.DelId?.Date,
            })
        this.setState({})
        if (this.state.actionData?.PlannedDate?.length > 1) {
            this.setState({ isSave: true })
        } else {
            this.setState({ isSave: false })
        }
        window.$("#deletepopupactual").modal("hide");
    }

    Post_Actual = (data) => {
        let apiUrl = API.TRAINING_PLAN + '/actual'
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate(`/trainingplanofyard`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    render() {
        let { classes, menuToggle } = this.props;
        const { isView, isSave } = this.state;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"PLAN" + "1"} className='  textNaviIcon' primary="Yard Documents" />
                                            <NavigateNextIcon id="PLAN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>{"Edit Training Plan"}</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                {!isView ? <></> : <>
                                    <td width="5%" className="border-right">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                    <td></td>
                                    <td></td>
                                    <td></td></>}
                                {this.state.value == 1 ? <>
                                    <td width="5%" className="border-right">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>

                                </> : <>
                                    {isView ? <></> : <>

                                        <td className="border-right text-center">
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                        <td className="border-right text-center">
                                            <span className={classes.button} disabled={isView ? true : false} onClick={this.EditSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Save</span> </td>
                                        <td className="border-right text-center">
                                            <span className={`${classes.button}`} onClick={this.OpenCancel} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span>
                                        </td>
                                        {/* <td className=" text-center">
                                            <span className={`${classes.button}`} disabled={isView ? true : false} style={{ minWidth: '70px' }} onClick={() => { this.OpenActualDelete() }}><img src={Delete} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Delete</span>
                                        </td> */}
                                    </>}
                                </>}
                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                    <td width="95%">
                                        {isView ? <></> : <>
                                            {this.state.value == 0 ? <>
                                                <button className={classes.button} disabled={(isView) ? true : false} onClick={() => this.EditSave()}><img src={Save} style={{ marginTop: '-4px', opacity: (isView) ? '0.5' : '' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} onClick={this.OpenCancel}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                                {/* <button className={`${classes.button} pl-3`} disabled={isView ? true : false} onClick={() => { this.OpenActualDelete() }}><img src={Delete} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Delete</button> */}
                                            </> : <></>}
                                        </>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mt-3 ml-2">{"Edit Training Plan"}</h6>}
                        <div className="row">
                            <div className={this.state.isMobile ? isView ? "row px-0 mt-n3" : "row ml-2 pr-4 mt-3" : isView ? "row pl-5 pt-2 pr-3" : "row pl-5 pt-2 pr-3"}>
                                <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-top border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-3 col-xl-2  ${this.state.isMobile ? " border-top border-left border-right" : "col-md-3 pt-2"}`}>
                                        <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>Training Title&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12   col-lg-9 col-xl-10   ${this.state.isMobile ? "pb-2 border-left border-right border-bottom col-md-12 pt-1" : "col-md-9 py-3"}`}>
                                        {this.state.actionData?.TrainingTitle && this.state.actionData?.TrainingTitle}
                                    </div>
                                </div>
                                {this.state.actionData?.PlannedDate?.length > 0 &&
                                    this.state.actionData?.PlannedDate?.map((r, ind) => (<>
                                        <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right"}`}>
                                            {this.state.isMobile && ind > 0 ? "" :
                                                ind == 0 ?
                                                    <div className={`col-12 col-sm-12  col-lg-3 col-xl-2  ${this.state.isMobile ? "border-left border-right" : "col-md-3"}`}>
                                                        <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>Planned Dates&nbsp;:</label>
                                                    </div> :
                                                    <div className={`col-12 col-sm-12  col-lg-3 col-xl-2  ${this.state.isMobile ? "border-left border-right" : "col-md-3"}`}>
                                                        <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}></label>
                                                    </div>}
                                            {isView == true && r.Date == "" ? "" :
                                                <div className={`col-12 col-sm-12 d-flex col-lg-5 col-xl-3 ${this.state.isMobile ? "" : ind == 0 ? "my-3" : "mb-3"}  ${this.state.isMobile ? "pb-3 border-left border-right col-md-12 pt-1" : "col-md-5"}`}>
                                                    {isView == true ? <label>{r.Date && moment(r.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</label> : <>
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            type="date"
                                                            fullWidth
                                                            id="type-date"
                                                            value={r.Date && moment(r.Date).format("yyyy-MM-DD")}
                                                            placeholder={r.Date && moment(r.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                            onChange={(e) => { this.handleInputChange(e, r, ind) }}
                                                            InputProps={{
                                                                className: `border-radius ${classes.inputfieldAlign}`
                                                            }}
                                                        />
                                                        <img className={this.state.actionData?.PlannedDate?.length - 1 == ind ? "img-disabled pl-2" : "pl-2 cursorPointer"} onClick={() => this.handleDelete(ind, r)} src={Delete} />
                                                        <br /></>}
                                                </div>}
                                        </div>
                                    </>))
                                }
                                {
                                    this.state.actionData?.TrainingTypeRoles?.length > 0 ?
                                        this.state.actionData?.TrainingTypeRoles?.map((role) => (
                                            <div className={`row mx-0 ${this.state.isMobile ? "" : "border-left border-right border-top border-bottom p-3"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-3 col-xl-2  ${this.state.isMobile ? "border-top border-left border-right" : "col-md-3"}`}>
                                                    <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>{role?.Type}&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12   col-lg-9 col-xl-10   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-9"}`}>
                                                    {role?.Roles?.length > 0 &&
                                                        role?.Roles?.map((r) => (<>
                                                            <label className="pb-2">{r}</label> <br />
                                                        </>))
                                                    }
                                                </div>
                                            </div>
                                        )) : <div className={`row  ${this.state.isMobile ? "ml-2" : "ml-0"} ${"border-top"}`} style={{ width: this.state.isMobile ? 'calc(100% - 20px)' : '' }}></div>
                                }
                            </div>
                        </div >
                        {/* <div class="modal fade " id="viewscreen" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                            <div class="modal-dialog modal-lg " role="document">
                                <div class="modal-content ">
                                    <div class="modal-body pt-0 pb-2 pr-0 pl-0 ">
                                        <div className="row">
                                            <div className="col-12 ">
                                                <div className='cursorPointer float-end mr-3' id="viewscreen" onClick={() => {
                                                    window.$('#viewscreen').modal('hide')

                                                }} >
                                                    <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                                </div>
                                            </div>
                                            <div className='col-12 text-center'>
                                                <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" style={{}} >
                                                    <div class="carousel-indicators">

                                                    </div>
                                                    <div class="carousel-inner" >
                                                        {this.state.Docs && this.state.Docs.map((i, ind) => (<>
                                                            <div class={ind === this.state.index ? "carousel-item active col-12 text-center align-middle" : " align-middle carousel-item col-12 text-center"}>
                                                                <div>
                                                                    <InnerImageZoom
                                                                        moveType="drag"
                                                                        zoomScale={2}
                                                                        hideCloseButton={true}
                                                                        src={i.FileUrl}
                                                                        hasSpacer={true}
                                                                        afterZoomIn={() => { $('#viewscreen > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                                                        afterZoomOut={() => { $('#viewscreen > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                                                    />
                                                                </div>
                                                                {this.state.Docs.length <= 1 ? "" : <>
                                                                    <button class="carousel-control-prev my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.preView(ind - 1)} data-bs-slide="prev">
                                                                        <span class="carousel-control-prev-icon black" aria-hidden="true"></span>
                                                                        <span class="visually-hidden">Previous</span>
                                                                    </button>
                                                                    <button class="carousel-control-next  my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.nextView(ind + 1)} data-bs-slide="next">
                                                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                                        <span class="visually-hidden">Next</span>
                                                                    </button>
                                                                </>}
                                                            </div>
                                                        </>))}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div class="modal fade p-5 mt-5" id="deletepopupfile" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                            <div class="modal-dialog" role="document">
                                <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                    <div class="modal-body pb-0">
                                        <h1 className="text-center">
                                            <img src={del}></img>

                                        </h1>
                                        <div className="text-center">
                                            <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                    </div>
                                    <div class="modal-footer border-top-0 m-auto">
                                        <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => { this.DeleteItem() }}><span className="" >Delete</span></button>
                                        <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#deletepopupfile").modal("hide"); }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade p-5 mt-5" id="deletepopupactual" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                            <div class="modal-dialog" role="document">
                                <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                    <div class="modal-body pb-0">
                                        <h1 className="text-center">
                                            <img src={del}></img>

                                        </h1>
                                        <div className="text-center">
                                            <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                    </div>
                                    <div class="modal-footer border-top-0 m-auto">
                                        <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => { this.DeleteItemActual() }}><span className="" >Delete</span></button>
                                        <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#deletepopupactual").modal("hide"); }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                            <div class="modal-dialog" role="document">
                                <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                    <div class="modal-body pb-0">
                                        <h1 className="text-center">
                                            <img src={del}></img>
                                        </h1>
                                        <div className="text-center">
                                            <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                    </div>
                                    <div class="modal-footer border-top-0 m-auto">
                                        <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                        <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#cancelpopup").modal("hide") }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                            <div class="modal-dialog" role="document">
                                <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                    <div class="modal-body pb-0">
                                        <h1 className="text-center">
                                            <img src={del}></img>
                                        </h1>
                                        <div className="text-center">
                                            <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                    </div>
                                    <div class="modal-footer border-top-0 m-auto">
                                        <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                        <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
        historyLog: state.commonReducer.historyLog || [],
    };
}

EditPlannedDate.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditPlannedDate))
);
